import { Dto, DtoWithId } from "@mango/core";
import { ArtikelLeverancier } from "./artikel-leverancier";


@Dto({ fullName: "CIJBorculo.Logic.ArtikelLeverancierPrijzen"})
export class ArtikelLeverancierPrijzen extends DtoWithId {
	artikelLeverancier: ArtikelLeverancier;
	prijs: number;
	datum: Date;
}
